export const navTexts = {
  en: {
    // 一级菜单
    menu: {
      products: 'Products',
      processes: 'Processes',
      technologies: 'Technologies',
      applications: 'Applications',
      industries: 'Industries',
      news: 'News',
      company: 'Company'
    },

    // Products 子菜单
    products: {
      // 分类标题
      vacuumIndustrialFurnace: 'Vacuum Industrial Furnace',
      verticalModular: 'Vertical Modular Heat Treatment System',
      nonFerrous: 'Non-ferrous Metal Heat Treatment Furnace',
      precisionCleaning: 'Precision Cleaning System',
      heatTreatmentMedia: 'Heat Treatment Media',

      // 产品项
      vacuumHeatTreatment: 'Vacuum Heat Treatment',
      vacuumBrazing: 'Vacuum Brazing',
      vacuumCarburizing: 'Vacuum Carburizing',
      vacuumNitriding: 'Vacuum Nitriding',
      vacuumAluminizing: 'Vacuum Aluminizing',
      vacuumSherardizing: 'Vacuum Sherardizing',
      physicalVaporDeposition: 'Physic Vapor Deposition',
      chemicalVaporDeposition: 'Chemical Vapor Deposition',
      fluorideIonCleaning: 'Florine Ion Cleaning',
      vacuumInductionMelting: 'Vacuum Induction Melting',
      vacuumInvestmentCasting: 'Vacuum Investment Casting',
      multiPurposeBottomLoad: 'Multi-purpose Bottom-load Line',
      shaftBottomLoad: 'Shaft Bottom-load Line',
      titanAlloys: 'Ti Alloy Solution',
      aluminumAlloys: 'Al Alloy Solution',
      magnesiumAlloys: 'Mg Alloy Solution',
      vacuumSolventCleaning: 'Vacuum Solvent Cleaning',
      vacuumHybridCleaning: 'Vacuum Hybrid Cleaning',
      aqueousPrecisionCleaning: 'Aqueous Precision Cleaning',
      quenchingMedia: 'Quenching Media',
      stopOffPaint: 'Stop-off Paint',
      cleaningAgent: 'Cleaning Agent'
    },

    // Processes 子菜单
    processes: {
      title: 'Processes',
      heatTreating: 'Heat Treating',
      surfaceEngineering: 'Surface Engineering',
      hotIsostaticPressing: 'Hot Isostatic Pressing',
      metalJoining: 'Metal Joining',
      testingAnalysis: 'Testing & Analysis',
      surfaceCleaning: 'Surface Cleaning',
      mediaSupport: 'Media Support',
      processesSupport: 'Processes support'
    },

    // Technologies 子菜单
    technologies: {
      title: 'Technologies',
      hpgq: 'High Pressure Gas Quenching (HPGQ)',
      lpc: 'Low Pressure Carburizing (LPC)',
      shenlizing: 'LT Gas Nitriding / Carburizing for SST(Shenlizing)',
      singerizingSst:
        'LT Plasma Nitriding / Carburizing for SST(Singerizing - SST)',
      singerizingTi: 'Plasma Nitriding for Titanium Alloy (Singerizing - Ti)',
      uhv: 'Ultra-high Vacuum (UHV)',
      uht: 'Ultra-high Temperature (UHT)',
      hybrid: 'Hybrid Solvent Cleaning (Hybrid)',
      cnp: 'Cyclic Nucleation Process (CNp)'
    },

    // Applications 子菜单
    applications: {
      title: 'Applications',
      gear: 'Gear and Transmission System',
      bearing: 'Bearing',
      springs: 'Springs',
      hydraulic: 'Hydraulic System',
      turbineBlade: 'Turbine Blade',
      landingGear: 'Landing Gear',
      gasTurnine: 'Gas Turbine',
      commonRail: 'Common Rail System',
      heatExchanger: 'Heat Exchanger',
      mim: 'MIM & Magnet',
      additiveManufacturing: 'Additive Manufacturing',
      applicationsSupport: 'Applications support'
    },

    // Industries 子菜单
    industries: {
      title: 'Industries',
      aerospace: 'Aeronautics & Astronautics',
      automotive: 'Automotive Industry',
      railTransit: 'Rail Transportation System',
      shipMarine: 'Marine & Offshore Engineering',
      newEnergy: 'New Energy',
      oilGas: 'Oil & Gas',
      tools: 'Tools and Molds',
      dieMoulds: 'Die & Moulds',
      product3c: '3C Products',
      medical: 'Medical Devices',
      semicon: 'Semiconductor',
      robotics: 'Robotics',
      industriesSupport: 'Industries support'
    },

    // News 子菜单
    news: {
      title: 'NEWS',
      pressReleases: 'Press Releases',
      articles: 'Articles',
      newsSupport: 'NEWS support'
    },

    // Company 子菜单
    company: {
      title: 'Company',
      aboutUs: 'About Us',
      history: 'History',
      careers: 'Careers',
      globalPartners: 'Global Partners',
      companySupport: 'Company support'
    },

    // 通用支持文本
    support: {
      heatTreatingSupport: 'Heat Treating support',
      surfaceEngineeringSupport: 'Surface Engineering support',
      hotIsostaticPressingSupport: 'Hot Isostatic Pressing support'
    }
  },

  zh: {
    // 一级菜单
    menu: {
      products: ' 产 品 ',
      processes: ' 工 艺 ',
      technologies: ' 技 术 ',
      applications: ' 应 用 ',
      industries: ' 行 业 ',
      news: ' 新 闻 ',
      company: ' 公 司 '
    },

    // Products 子菜单
    products: {
      // 分类标题
      vacuumIndustrialFurnace: '真空工业炉',
      verticalModular: '立式模块化热处理生产线',
      nonFerrous: '轻合金热处理炉',
      precisionCleaning: '精密清洗系统',
      heatTreatmentMedia: '热处理介质',

      // 产品项
      vacuumHeatTreatment: '真空热处理炉',
      vacuumBrazing: '真空钎焊炉',
      vacuumCarburizing: '真空渗碳炉',
      vacuumNitriding: '真空渗氮炉',
      vacuumAluminizing: '真空渗铝炉',
      vacuumSherardizing: '真空粉末渗锌炉',
      physicalVaporDeposition: 'PVD 物理气相沉积设备',
      chemicalVaporDeposition: 'CVD 化学气相沉积设备',
      fluorideIonCleaning: 'FIC 氟离子清洗设备',
      vacuumInductionMelting: 'VIM 真空感应熔炼炉',
      vacuumInvestmentCasting: 'VIM-IC 真空感应熔炼和精密铸造炉',
      multiPurposeBottomLoad: '底装料多用炉生产线',
      shaftBottomLoad: '立式底装料热处理生产线',
      titanAlloys: '钛合金固溶炉',
      aluminumAlloys: '铝合金固溶炉',
      magnesiumAlloys: '镁合金固溶炉',
      vacuumSolventCleaning: '真空溶剂清洗',
      vacuumHybridCleaning: '真空混合清洗',
      aqueousPrecisionCleaning: '水基精密清洗',
      quenchingMedia: '淬火介质',
      stopOffPaint: '防渗涂料',
      cleaningAgent: '清洗剂'
    },

    // Processes 子菜单
    processes: {
      title: '工艺',
      heatTreating: '热处理',
      surfaceEngineering: '表面工程',
      hotIsostaticPressing: '热等静压',
      metalJoining: '金属连接',
      testingAnalysis: '检测与分析',
      surfaceCleaning: '表面清洗',
      mediaSupport: '介质支持',
      processesSupport: '工艺介质'
    },

    // Technologies 子菜单
    technologies: {
      title: '技术',
      hpgq: '高压气体淬火 (HPGQ)',
      lpc: '低压渗碳 (LPC)',
      shenlizing: '不锈钢低温气体渗氮/渗碳 (Shenlizing) ',
      singerizingSst: '不锈钢低温离子渗氮/渗碳 (Singerizing - SST)',
      singerizingTi: '钛合金离子渗氮 (Singerizing - Ti)',
      uhv: '超高真空 (UHV)',
      uht: '超高温 (UHT)',
      hybrid: '混合清洗 (Hybrid)',
      cnp: '循环型核工艺 (CNp)'
    },

    // Applications 子菜单
    applications: {
      title: '应用',
      gear: '齿轮与传动系统',
      bearing: '轴承',
      springs: '弹簧',
      hydraulic: '液压系统',
      turbineBlade: '涡轮叶片',
      landingGear: '起落架',
      gasTurnine: '燃气轮机',
      commonRail: '共轨系统',
      heatExchanger: '换热器',
      mim: 'MIM与磁体',
      additiveManufacturing: '增材制造',
      applicationsSupport: '应用支持'
    },

    // Industries 子菜单
    industries: {
      title: '行业',
      aerospace: '航空航天',
      automotive: '汽车工业',
      railTransit: '轨道交通',
      shipMarine: '船舶与海洋工程',
      newEnergy: '新能源',
      oilGas: '石油与天然气',
      tools: '工具与模具',
      dieMoulds: '模具',
      product3c: '3C产品',
      medical: '医疗器械',
      semicon: '半导体',
      robotics: '机器人',
      industriesSupport: '产业支持'
    },

    // News 子菜单
    news: {
      title: '新闻',
      pressReleases: '简讯',
      articles: '特稿',
      newsSupport: '新闻支持'
    },

    // Company 子菜单
    company: {
      title: '公司',
      aboutUs: '关于先越',
      history: '先越历程',
      careers: '职业发展',
      globalPartners: '全球伙伴',
      companySupport: '公司支持'
    },

    // 通用支持文本
    support: {
      heatTreatingSupport: '热处理支持',
      surfaceEngineeringSupport: '表面工程支持',
      hotIsostaticPressingSupport: '热等静压支持'
    }
  }
}

/**
 * 获取当前语言的导航文本
 */
export const getNavTexts = (lang) => {
  return navTexts[lang] || navTexts['en']
}
